import { render, staticRenderFns } from "./RequestDeletionSidebar.vue?vue&type=template&id=5afbbf6a"
import script from "./RequestDeletionSidebar.vue?vue&type=script&lang=js"
export * from "./RequestDeletionSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports